export default {
  en: ['days', 'hours', 'minutes', 'seconds'],
  en_IE: ['days', 'hours', 'minutes', 'seconds'],
  fr: ['jours', 'heures', 'minutes', 'secondes'],
  es: ['días', 'horas', 'minutos', 'segundos'],
  se: ['dagar', 'timmar', 'minuter', 'sekunder'],
  de: ['tage', 'zeiten', 'minute', 'sekunden'],
}
